import React from "react";
import CustomSelect from "../../../components/CustomFormFields/CustomSelect";

const WidgetFilterBox = ({ 
  yearsFilter, 
  onYearsChange, 
  statusFilter, 
  onStatusChange, 
  selectedStatus, 
  selectedYear 
}) => {
  return (
    <div className="widget-toolbox row">
      <div className="col">
        <CustomSelect 
          selectLabel="Status:"
          optionsList={statusFilter}
          onChange={onStatusChange}
          value={selectedStatus}
        />
      </div>
      <div className="col-auto d-flex justify-content-center">
        <CustomSelect 
          border={true}
          arrowIconClass="far fa-calendar-alt"
          optionsList={yearsFilter}
          onChange={onYearsChange}
          value={selectedYear}
        />
      </div>
    </div>
  );
};

export default WidgetFilterBox;
